<template>
  <Form :ref="refName" :model="formModel" :rules="formRules" label-position="top">
    <FormItem :label="_vm.$t('dictmenu.upload')" prop="filename" class="layout100">
        <Upload
        :value="formModel.filename"
          type="drag"
          :before-upload="handleUpload"
          action="//jsonplaceholder.typicode.com/posts/">
          <div style="padding: 20px 0">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
              <p>{{ _vm.$t('dictmenu.uploadxls') }}</p>
          </div>
      </Upload>
      <div>{{formModel.filename?formModel.filename.name:''}}</div>
    </FormItem>
    <a style="margin-top:16px" href="http://pcphp.test.xcthings.com/example/example.xlsx" download="uploads_xls.xlsx">{{ _vm.$t('downloadexample') }}</a>
  </Form>

</template>

<script>
  import {renderFormMixins} from '@/mixins/renderFormMixins'
  export default {
    name: "addModalCode",
    mixins: [renderFormMixins],
    data() {                    
      return {
        formModel: {
          filename: null
        },
        formRules: {
          filename: [
            {required: true, type:'object',message:this._vm.$t('dictmenu.uploadPlaceHolder'), trigger: 'change'}
          ]
        }
      }
    },
    props: {
      _vm: {},
    },
    components: {},
    computed: {
      // getModalCode(){
      //   console.log(this._vm.$store.state.product.ModelCode);
      //   //
      //   return this._vm.$store.state.product.ModelCode
      // }
    },
    methods: {
      handleUpload(file) {
        if (file.name.indexOf('.xls')>-1 || file.name.indexOf('.xlsx')>-1) {
          this.$set(this.formModel,'filename',file)
        } else {
          this.$Message.error(this._vm.$t('dictmenu.uploadPlaceHolderType'))
        }
        return false;
      },
    },
    mounted() {

    },
    created() {
      // if (this.setData != undefined) {
      //   Object.assign(this.formModel,this.setData);
      // }
      // if(!this.edit){
      //   this.$set(this.formModel,'model_code',this.model_code)
      // }

    }
  }
</script>

<style scoped>
  .layout50, .layout100 {
    margin-bottom: 15px;
  }

  .layout50 {
    width: calc(50% - 12px);
  }

  .layout100 {
    width: calc(100% - 12px);
  }

  .formHeight {
    height: 400px;
    overflow-y: auto;
  }
</style>
